import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetEditJobLink(jobId: string) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/${jobId}/edit-job`;
}
